import { useState, useCallback } from 'react';
import '../../Styles/Admin.css';
import playstore from '../../assets/playstore.png';
import logo_white from '../../assets/logotipo_white.png';
import logo_black from '../../assets/logtipo_black.png';

import izenuAPI from '../../services/izenuAPI';

const ShowArtistLogin = ({ show, setShow }) => {
    const [view, setView] = useState(show);
    const [pwd, setPwd] = useState("");
    const [email, setEmail] = useState("");
    const [load, setLoad] = useState(false);

    const login = useCallback(async () => {

        try {

            setLoad(true);

            const { data: resp } = await izenuAPI.get(`/login/browserLogin.php?email=${email}&password=${pwd}`);

            setEmail("");
            setPwd("");

            if (resp.response) {
                //setUser(r.distributor);
                localStorage.setItem('user', JSON.stringify(resp.user));
                localStorage.setItem('name', resp.user.name);
                localStorage.setItem('id', resp.user.user_id);
                localStorage.setItem('type', 'artist');
                localStorage.setItem('token', resp.token);
                window.location.href = '/';
                alert("Bem-vindo!");
            } else {
                alert("Utilizador não encontrado!");
            }

            setLoad(false);
            setShow(false);
        } catch (error) {
            setLoad(false);
            setShow(false);
            console.log(error);
        }

    }, [pwd, email]);

    if (show) {
        return (
            <div className='bg-slate-700/70 absolute h-full w-full top-0 left-0 flex justify-center items-center'>
                <div className='relative w-full h-full flex justify-center items-center'>

                    <div className='relative bg-slate-50 rounded-md p-20 flex flex-col justify-center gap-3 item-center bg-slate-200 w-1/3 min-h-1/3'>
                        <div className='mb-10'>
                            <img src={logo_black} className="w-40" />
                        </div>

                        <button onClick={() => setShow(false)} className='absolute right-5 w-10 h-10 p-20 top-0 border-2 border-slate-950 p-5 rounded-full'>
                            <span className='text-slate-950 text-lg'>X</span>
                        </button>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            login();
                        }} className='flex flex-col gap-5' >
                            <p className="text-left">Email ou nº de telefone</p>
                            <input value={email} required onChange={(e) => {
                                setEmail(e.target.value);
                            }} type='text' className="border-slate-300 rounded-md round-full" placeholder='Email ou numero de telefone' />
                            <p className="text-left">Palavra passe</p>
                            <input value={pwd} required onChange={(e) => setPwd(e.target.value)} type='password' className="border-slate-300 rounded-md mb-5 round-full" placeholder='Palavra passe' />
                            <button type="submit" className='bg-slate-950 rounded-full p-3 w-1/3'>
                                <span className='text-neutral-50 font-bold'>Entrar</span>
                            </button>
                        </form>
                        {load ? (
                            <div className='absolute bg-slate-700/70 left-0 right-0 w-full h-full flex justify-center items-center'>
                                <div role="status flex flex-col justify-center items-center">
                                    <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}

                    </div>
                </div>
            </div>
        )
    } else {
        return <></>;
    }
}

export default function Home() {

    const [show, setShow] = useState(false);
    return (<div class="h-full">
        <header class="inset-x-0 top-0 z-50 bg-gradient-to-r from-indigo-900 to-purple-800">
            <nav class="flex w-items-center w-2xl justify-between p-6 " aria-label="Global">
                <div class="flex lg:flex-1">
                    <a href="#" class="-m-1.5 p-1.5 flex">
                        <img class="h-8 w-auto" src={logo_white} alt="" />
                    </a>
                </div>
                <div class="lg:flex lg:flex-1 items-center gap-5 lg:justify-end">
                    <button onClick={() => setShow(true)} class="border-slate-700 border bg-slate-700/50 px-10 py-1 rounded-full">
                        <span class="text-gray-100 font-semibold">Artista</span>
                    </button>
                    <a href="/distributor" class="text-sm font-semibold leading-6 text-gray-100">Log in <span aria-hidden="true">&rarr;</span></a>
                </div>
            </nav>
        </header>

        <div class="relative ">
            <div class="w-full h-fit py-40 px-20 bg-gradient-to-r from-indigo-900 to-purple-800">
                <h1 class="text-4xl font-bold tracking-tight text-gray-100 sm:text-6xl">Africa Beats</h1>
                <p class="mt-6 text-lg leading-8 text-gray-100">Os teus artistas favoritos e os teus amigos na mesma plataforma</p>
                <p class="mt-6 text-lg leading-8 text-gray-100">Obtem o izenu em todas as lojas</p>
                <div class="flex gap-5 items-center justify-center mt-10">
                    <a href="https://apps.apple.com/ao/app/izenu/id6448960343" target='_blank'>
                        <img style={{ height: 60, width: 'auto' }} src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.izenu.izenu&pcampaignid=web_share" target='_blank'>
                        <img style={{ height: 60, width: 'auto' }} src={playstore} />
                    </a>

                </div>
                <div class="flex items-center justify-center pt-10">
                    <div style={{ width: 300 }} class="flex items-center justify-center gap-5">
                        <span style={{ color: '#FFFFFF', opacity: 0.5 }} class="inline-block text-xl font-semibold">+434</span>
                        <span style={{ color: '#FFFFFF', opacity: 0.5 }} class="text-left inline-block">
                            Novos utilizadores aderiram
                            Última semana
                        </span>
                    </div>
                </div>
            </div>
            <div class="bg-blue mx-auto max-w-2xl py-12">
                <div class="text-center flex flex-col gap-5">
                    <p style={{ color: '#14274E' }} class="mt-6 text-lg leading-8 text-black-100 font-semibold">Confiável por muitos utilizadores e parceiros</p>
                    <div class="flex items-center justify-center gap-5">
                        <span class="font-extrabold text-xl text-gray-500 flex">MULTICAIXA EXPRESS</span>
                        <span class="font-extrabold text-xl text-gray-500">BIZNESS</span>
                        <span class="font-extrabold text-xl text-gray-500">Radio Ecclesia</span>
                        <span class="font-extrabold text-xl text-gray-500">Afriradio</span>
                        <span class="font-extrabold text-xl text-gray-500">Radio MFM</span>
                    </div>
                </div>
            </div>
            <div class="w-full h-fit py-10 px-20">
            </div>


        </div>

        <footer class="bg-white rounded-lg shadow-sm m-4 dark:bg-gray-800">
            <div class="w-full mx-auto max-w-screen-xl flex flex-row p-4 md:flex md:items-center md:justify-between">
                <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2025 <a href="https://flowbite.com/" class="hover:underline">Izenu™</a>. Todos os direitos reservado.
                </span>
                <ul class="flex flex items-center mt-3 text-sm font-medium text-gray-950 sm:mt-0">
                    <li className="flex">
                        <a href="#" class="text-gray-500 hover:underline me-4 md:me-6">Acerca</a>
                    </li>
                    <li className="block">
                        <a href="#" class="text-gray-500 hover:underline me-4 md:me-6">Politica de privacidade</a>
                    </li>

                    <li className="flex">
                        <a href="#" class="text-gray-500 hover:underline">Contacto</a>
                    </li>
                </ul>
            </div>
        </footer>
        <ShowArtistLogin show={show} setShow={setShow} />
    </div>
    );

}